import { render, staticRenderFns } from "./CategorySelection.vue?vue&type=template&id=056076f0&scoped=true"
import script from "./CategorySelection.vue?vue&type=script&lang=js"
export * from "./CategorySelection.vue?vue&type=script&lang=js"
import style0 from "./CategorySelection.vue?vue&type=style&index=0&id=056076f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056076f0",
  null
  
)

export default component.exports